import React from "react";
import {PropTypes} from "prop-types";
import classNames from "classnames";
import BuildIcon from "@material-ui/icons/BuildOutlined";

import styles from "./rasterizing-message.module.scss";

function RasterizingMessage({className}) {
  return (
    <div className={classNames(styles.root, className)}>
      <BuildIcon />
      <span>Конвертируется...</span>
    </div>
  );
}

RasterizingMessage.propTypes = {
  className: PropTypes.string
};

export default RasterizingMessage;
